<template>
    <form
        class="hero-block-inner__form form-account"
        @submit.prevent="onSubmit"
    >
        <div class="form-account__title">Sign In</div>
        <div class="form-account__row form-row">
            <v-text-field
                ref="username"
                v-model.lazy="model.username"
                v-validate="'required'"
                prepend-inner-icon="person"
                type="email"
                name="username"
                :class="{
                    'v-input--is-dirty': dirtyEmail,
                }"
                :label="$t('fields.email')"
                :data-vv-as="$t('fields.email')"
                :error-messages="errors.collect('username')"
                outlined
                persistent-placeholder
            ></v-text-field>
        </div>
        <div class="form-account__row form-row">
            <v-text-field
                v-model.lazy="model.password"
                v-validate="'required|min:8|max:64'"
                prepend-inner-icon="lock"
                name="password"
                :class="{
                    'v-input--is-label-active ': dirtyPwd,
                }"
                :type="visibility ? 'text' : 'password'"
                :label="$t('fields.password')"
                :data-vv-as="$t('fields.password')"
                :error-messages="errors.collect('password')"
                :append-icon="visibility ? 'visibility' : 'visibility_off'"
                outlined
                persistent-placeholder
                @click:append="() => (visibility = !visibility)"
            ></v-text-field>
        </div>
        <div class="form-account__row form-row">
            <button type="submit" class="form-row__submit">Login</button>
        </div>
        <div class="form-account__links">
            <router-link class="form-account__link" to="/account/reset-password"
                >Reset password</router-link
            >
            <router-link class="form-account__link" to="/account/sign-up"
                >Sign up now</router-link
            >
        </div>
    </form>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        $_veeValidate: {
            validator: 'new',
        },
        data() {
            return {
                model: {
                    username: null,
                    password: null,
                },
                interval: null,
                visibility: false,
                yourEmail: '',
                dirtyEmail: null,
                dirtyPwd: null,
                yourPassword: '',
                showPassword: false,
            };
        },
        mounted() {
            const dict = {
                custom: {
                    email: {
                        email: 'Invalid Email',
                        required: 'Email field is required',
                    },
                    password: {
                        required: 'Password field is required',
                        min: 'Your Password must be at least 8 characters.',
                        max: 'Your Password may not be greater than 24 characters',
                    },
                },
            };

            this.$validator.localize('en', dict);
        },
        methods: {
            ...mapActions('auth', ['login']),

            /**
             * Login user on submit
             * @returns {boolean}
             */
            async onSubmit() {
                const validation = await this.$validator.validateAll();
                if (!validation) return;

                this.login(this.model);
            },
        },
    };
</script>

<style scoped lang="stylus">
    @import '../assets/styles/pages/account';
</style>
